// Legal pages chrome — the link row under the sign-in card and on the legal
// pages themselves (`legal/LegalLinks.tsx`), and the legal pages' own frame
// (`legal/LegalPage.tsx`). The pages' text is not here: it lives in
// `src/legal/` as plain data, with the evidence for each claim.

import { PUBLIC_PRODUCT_NAME } from "@loom/shared/brand";

import type { MsgSection } from "./types.js";

export const legal: MsgSection = {
  "legal.links": { en: "Legal", de: "Rechtliches" },
  "legal.privacy": { en: "Privacy", de: "Datenschutz" },
  "legal.imprint": { en: "Imprint", de: "Impressum" },
  "legal.support": { en: "Support", de: "Support" },
  "legal.language": { en: "Language", de: "Sprache" },
  "legal.updated": { en: "Last updated: {date}", de: "Zuletzt geändert: {date}" },
  "legal.contents": { en: "On this page", de: "Auf dieser Seite" },
  "legal.home": { en: `${PUBLIC_PRODUCT_NAME} home`, de: `${PUBLIC_PRODUCT_NAME}-Startseite` },
};
